import React, { Component } from "react";
import { Dropdown as DropdownSemantic, Form } from "semantic-ui-react";
import { connect } from "react-redux";
import InputField from "../../commonComponents/Input";
import DateInputField from "../../commonComponents/SematicDateField";
import { DropDown } from "../../commonComponents/dropDownCommon";
import { SearchDropDown } from "../../commonComponents/SearchDropDown";
import * as actionCreators from "../actions";
import { displayMasterItem } from "./util";
import { transportationFields } from "../util/supportedFields/transportationForm";
import "../styleSheets/theme/forms/genericform.scss";
import { get } from "lodash";
import { saveImporterField } from "../api/setFormData";
import PscHeaderReason from "./headerReason";
import { fetchSelectedReasonCodes, totalHeaderReasonSelected } from "../util";
import { entryTypeFields } from "../util/supportedFields/entryType";
import KNDatePicker from "../../util/KNDatePicker";
import {
  convertToTimezone,
  shortDateFormatterV2WithoutTz,
} from "../../util";
export class TransportationForm extends Component {
  constructor() {
    super();
    this.state = {
      formInfo: {},
    };
    for (let key in transportationFields) {
      transportationFields[key].errors = [];
      transportationFields[key].valid = [];
    }
  }

  componentWillMount() {
    this.selectedReasons = this.props.pscData.headerCodes
      ? fetchSelectedReasonCodes(
          this.props.pscData.headerCodes,
          this.props.tabName
        )
      : [];
    const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
    this.enableDisableFrom(isTheOwningBroker && 
      this.selectedReasons.length > 0 &&
        (get(this.props, "pscState.value.state") === "STATE_PSC_IN_PROCESS" ||
          get(this.props, "pscState.value.state") === "STATE_PSC_READY")
    );
  }

  addErrorClass(fieldName, fieldType) {
    const inputField = document.querySelector(
      "#" + fieldName + window.shipmentId
    );
    inputField && inputField.classList.add("errorInput");
  }

  removeErrorClass(fieldName, fieldType) {
    try {
      const inputField = document.querySelector(
        "#" + fieldName + window.shipmentId
      );
      inputField.classList.remove("errorInput");
    } catch (e) {
      console.error(e);
    }
  }
  enableDisableFrom = (enableForm) => {
    this.setState({
      enableForm: enableForm,
    });
  };

  // Check field Validity
  validateField(fieldName, value) {
    let warning = 0;
    // const newState = Object.assign({}, this.state);
    // newState.formInfo[fieldName] = value;
    // this.setState(newState);
    transportationFields[fieldName].errors = [];
    transportationFields[fieldName].valid = true;
    if (
      transportationFields[fieldName].rules &&
      transportationFields[fieldName].rules.length > 0
    ) {
      transportationFields[fieldName].rules.forEach((rule) => {
        console.log(rule.test(value));
        if (!rule.test(value)) {
          transportationFields[fieldName].errors.push(rule.message);
          transportationFields[fieldName].valid = false;
        }
      });
    }
    Object.keys(transportationFields).forEach((field) => {
      if (!transportationFields[field].valid) {
        warning++;
      }
    });
    this.props.updateTransportationErrorWarning(warning);

    if (transportationFields[fieldName].errors.length) {
      this.addErrorClass(fieldName, transportationFields);
    } else {
      this.removeErrorClass(fieldName, transportationFields);
    }
  }
  // onChangeCarrierCode(event,ccarriercode){
  //   console.log('ccarriercode: ', ccarriercode);
  //   // this.props.updateTransportationField("airCarrierCode", ccarriercode.value.code)
  //   // this.props.saveTransportationField("airCarrierCode", ccarriercode.value.code);
  //   // this.props.updateTransportationField("importingCarrier", ccarriercode.value.name);//Conveyance name is always the same!
  //   // this.props.saveTransportationField("importingCarrier", ccarriercode.value.name);//Conveyance name is always the same!

  // }
  render() {
    function humanizeTransportText(mytext) {
      const allowedTransports = {
        MOT_OCEAN_NON_CONTAINER: "10 - Vessel, Non-Containerized",
        MOT_OCEAN: "11 - Vessel, Containerized",
        MOT_BORDER_WATER_BORNE: "12 - Border Water Borne",
        MOT_RAIL: "20 - Rail, Non-Containerized",
        MOT_RAIL_CONTAINER: "21 - Rail, Containerized",
        MOT_TRUCK: "30 - Truck, Non-Containerized",
        MOT_TRUCK_CONTAINER: "31 - Truck, Containerized",
        MOT_AUTO: "32 - Auto",
        MOT_PEDESTRIAN: "33 - Pedestrian",
        MOT_ROAD_OTHER: "34 - Road, Other",
        MOT_AIR: "40 - Air, Non-Containerized",
        MOT_AIR_CONTAINER: "41 - Air, Containerized",
        MOT_MAIL: "50 - Mail",
        MOT_PASSENGER_HAND_CARRIED: "60 - Passenger, Hand Carried",
        MOT_FIXED_TRANSPORT: "70 - Fixed Transport",
      }
      return allowedTransports[mytext];
    }
    const {
      transportInfoValues,
      modeOfTransportList,
      updateTransportationField,

      updateTransportDate,
      saveTransportationField,
      saveTransportationDateField,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      rbCounterID,
      isDisabled,
      FIELD_META,
      bolInfoValues,
      saveBOLInfoField,
      updateBOLInfoField,

      updateField,
      saveHeaderReason,
      fieldValidation,
      saveEntryTypeField,
      updateEntryTypeField,
      entryTypeValues,
      countryList,
    } = this.props;
    let modeOfTransportListmodified = [];
    for (let onemode of modeOfTransportList) {
      if(!humanizeTransportText(onemode.stringVal))continue;
      modeOfTransportListmodified.push({
        id: onemode.stringVal,
        description: humanizeTransportText(onemode.stringVal),
      });
    }
    modeOfTransportListmodified.sort((a, b) =>
      a.description > b.description ? 1 : -1
    );
    const modeOfTransport = transportInfoValues.modeOfTransport.replace(
      "MOT_",
      ""
    );

    let foreignPortOfLadingCode = transportInfoValues.foreignPortOfLadingCode;
    if (
      !foreignPortOfLadingCode &&
      transportInfoValues.foreignPortOfLading &&
      transportInfoValues.foreignPortOfLading.split(":")
    ) {
      foreignPortOfLadingCode =
        transportInfoValues.foreignPortOfLading.split(":")[0];
    }
    let USportOfUnladingCode = transportInfoValues.USportOfUnladingCode;
    if (
      !USportOfUnladingCode &&
      transportInfoValues.USportOfUnlading &&
      transportInfoValues.USportOfUnlading.split(":")
    ) {
      USportOfUnladingCode = transportInfoValues.USportOfUnlading.split(":")[0];
    }
    let truuck = modeOfTransport == "TRUCK";
    let raaiil = modeOfTransport.indexOf("RAIL") >= 0;

    let arrivalDate = parseInt(get(transportInfoValues, "arrivalDate.epochs", "-999"));
    let destTimeZone = get(transportInfoValues, "destTimeZone") || "UTC";
    if(destTimeZone.match(/UTC.?\d+:\d+/g)){
      console.error("INVALID TIMEZONE "+destTimeZone)
      destTimeZone="UTC";
    }
    if(destTimeZone=='_BLANK_'){
      console.error("INVALID TIMEZONE "+destTimeZone)
      destTimeZone="UTC";
    }
    let curtime = new Date(arrivalDate);
    let differenceBetweenBrowserTZAndPortTZ = convertToTimezone(curtime,destTimeZone).getTime() - curtime.getTime();
    let differenceBetweenPortTZAndUTC = convertToTimezone(curtime,destTimeZone).getTime() - convertToTimezone(curtime, 'UTC' ).getTime();
    let twelveHours = 1000*60*60*12;
    
    
    let pscWarningAlertShow = this.selectedReasons.length<=0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY')

    return (
      <React.Fragment>
        {(get(this.props, "pscData.pscShipmentId") || this.props.isAPscShipment) && (
          <PscHeaderReason
            {...this.props}
            pscState={get(this.props, "pscState.value.state")}
            totalHeaderReasonSelected={totalHeaderReasonSelected(
              this.props.pscData
            )}
            selectedOptions={this.selectedReasons}
            saveHeaderReason={saveHeaderReason}
            enableDisableFrom={this.enableDisableFrom}
          />
        )}
        <Form id="transportation-form"  title={pscWarningAlertShow?"Must select a PSC reason before you can edit":""}>
          <div className="merged-column">
            <Form.Group className="merged-row specialHeighht">
              <DropDown
                id="modeOfTransport"
                label="Mode of Transport"
                className="field-bg dropdown100 modeOfTransport"
                width={6}
                hidePrefix={true}
                text={humanizeTransportText(
                  transportInfoValues.modeOfTransport
                ) || transportInfoValues.modeOfTransport}
                data={modeOfTransportListmodified}
                errors={transportationFields["modeOfTransport"].errors}
                onChange={(value) => {
                  this.validateField("modeOfTransport", value);
                  updateTransportationField("modeOfTransport", value);
                  saveTransportationField("modeOfTransport", value);
                }}
                {...FIELD_META}
                disabled={
                  this.state.enableForm === true
                    ? false
                    : (isDisabled("transportationSection")  && isDisabled("modeOfTransport"))
                }
              />
              {modeOfTransport == "AIR" ? (
                // <InputField
                //   id="importingCarrier"
                //   label="CARRIER CODE"
                //   width={6}
                //   value={bolInfoValues.airCarrierCode}
                //   onChange={(value) => updateBOLInfoField("airCarrierCode", value)}
                //   onBlur={(value) => {
                //     saveBOLInfoField("airCarrierCode");
                //   }}
                //   {...FIELD_META}
                // />

                <DropDown
                  id="airCarrierCode"
                  label="Carrier Code"
                  className="field-bg dropdown100"
                  width={6}
                  text={displayMasterItem(
                    transportInfoValues.airCarrierCode,
                    transportInfoValues.carrierCodeList
                  )}
                  data={transportInfoValues.carrierCodeList}
                  errors={transportationFields["modeOfTransport"].errors}
                  onChange={(value) => {
                    // this.validateField("transname", value);
                    updateTransportationField("airCarrierCode", value);
                    saveTransportationField("airCarrierCode", value);
                    window.airCarrierCode = value;
                    let thisonecarrier =
                      transportInfoValues.carrierCodeList.find(
                        (a) => a.twoLetterCode == value
                      );
                    let mycarriername = thisonecarrier
                      ? thisonecarrier.companyName
                      : "Unknown";
                    updateTransportationField(
                      "importingCarrier",
                      mycarriername
                    );
                    saveTransportationField("importingCarrier", mycarriername);
                  }}
                  {...FIELD_META}
                  disabled={
                    this.state.enableForm === true
                      ? false
                      : (isDisabled("transportationSection") && isDisabled("importingCarrier"))
                  }
                />
              ) : (
                <SearchDropDown
                  id="importingCarrier"
                  label={
                     raaiil ? "VESSEL/CARRIER NAME" : truuck  ? "CARRIER NAME" : "VESSEL NAME"
                  }
                  hidePrefix = {true}
                  width={6}
                  disabled={
                    raaiil ||
                    (this.state.enableForm === true
                      ? false
                      : (isDisabled("transportationSection")  && isDisabled("importingCarrier")))
                  }
                  type="text"
                  fieldType="VESSEL"
                  className="field-bg"
                  value={
                    typeof transportInfoValues.importingCarrier === "string"
                      ? ((transportInfoValues.importingCarrier == ', _BLANK_' || transportInfoValues.importingCarrier == '_BLANK_') ? "": transportInfoValues.importingCarrier )
                      : typeof transportInfoValues.importingCarrier === "object" ? `${transportInfoValues.importingCarrier.title}`
                      :"" 
                  }
                  currentCountry_aa="US"
                  errors={
                    fieldValidation.validObjects_bl[
                      `Transportqwqr${"importingCarrier"}`
                    ]
                  }
                  fullPayload={true}
                  portType={"VESSEL"}
                  onChange={(value) => {
                    updateTransportationField("importingCarrier", value);
                  }}
                  // onChange={(value) => {
                  //   let newObj = {
                  //     carrierName: get(value, "title", ""),
                  //     carrierIMO: get(value, "payload", ""),
                  //   };
                  //   let importingCarrier = newObj.carrierIMO+", "+newObj.carrierName;
                  //   updateTransportationField("importingCarrier", importingCarrier);
                  // }}
                  onBlur={(value) => {
                    if(truuck){
                      this.validateField("importingCarrier", value);
                      updateTransportationField("importingCarrier", value)
                      saveTransportationField(
                        "importingCarrier",
                        value
                      );
                    }else {
                    
                    let newObj = {
                      carrierName: get(value, "title", "_BLANK_"),
                      carrierIMO: get(value, "payload", ""),
                    };
                    let importingCarrier = newObj.carrierName;
                    this.validateField("importingCarrier", importingCarrier);
                    saveTransportationField(
                      "importingCarrier",
                      importingCarrier
                    );
                  }
                }
                
                }
                  {...FIELD_META}
                />
                // <InputField
                //   id="importingCarrier"
                //   label={(truuck || raaiil)?"VESSEL/CARRIER NAME":"VESSEL NAME"}
                //   width={6}
                //   value={transportInfoValues.importingCarrier}
                //   errors={fieldValidation.validObjects_bl[`Transportqwqr${'importingCarrier'}`]}
                //   onChange={(value) => updateTransportationField("importingCarrier", value)}
                //   disabled={raaiil || (this.state.enableForm === true ? false : isDisabled('transportationSection'))}
                //   onBlur={(value) => {
                //     this.validateField("importingCarrier", value);
                //     saveTransportationField("importingCarrier", value);
                //   }}
                //   {...FIELD_META}
                // />
              )}
              {modeOfTransport == "AIR" ? (
                <InputField
                  id="flightNo"
                  label="FLIGHT NUMBER"
                  width={6}
                  value={transportInfoValues.flightNo}
                  errors={transportationFields["flightNo"].errors}
                  onChange={(value) =>
                    updateTransportationField("flightNo", value)
                  }
                  onBlur={(value) => {
                    this.validateField("flightNo", value);
                    saveTransportationField("flightNo", value);
                  }}
                  {...FIELD_META}
                  disabled={
                    this.state.enableForm === true
                      ? false
                      : isDisabled("flightNo")
                  }
                />
              ) : truuck ? (
                <InputField
                  id="truckNo"
                  label={"TRUCK/TRAILER NUMBER"}
                  width={6}
                  value={transportInfoValues.truckNo}
                  errors={
                    fieldValidation.validObjects_bl[`Transportqwqr${"truckNo"}`]
                  }
                  onChange={(value) =>
                    updateTransportationField("truckNo", value)
                  }
                  onBlur={(value) => {
                    this.validateField("truckNo", value);
                    saveTransportationField("truckNo", value);
                  }}
                  disabled={
                    this.state.enableForm === true
                      ? false
                      : isDisabled("transportationSection")
                  }
                  {...FIELD_META}
                />
              ) : (
                <InputField
                  id="tripInformation"
                  label={raaiil ? "TRIP NUMBER" : "VOYAGE"}
                  width={6}
                  value={transportInfoValues.tripInformation}
                  errors={
                    fieldValidation.validObjects_bl[
                      `Transportqwqr${"tripInformation"}`
                    ]
                  }
                  onChange={(value) =>
                    updateTransportationField("tripInformation", value)
                  }
                  onBlur={(value) => {
                    this.validateField("tripInformation", value);
                    saveTransportationField("tripInformation", value);
                  }}
                  disabled={
                    raaiil ||
                    (this.state.enableForm === true
                      ? false
                      : isDisabled("voyageNo"))
                  }
                  {...FIELD_META}
                  maxLength={32}
                />
              )}
            </Form.Group>

            <Form.Group className="merged-row">
              <SearchDropDown
                width={6}
                id="foreignPortOfLadingCode"
                disabled={
                  truuck ||
                  raaiil ||
                  (this.state.enableForm === true
                    ? false
                    : isDisabled("transportationSection"))
                }
                type="text"
                fieldType="POL"
                label={
                  "Foreign Port of Lading " +
                  (truuck || raaiil ? `(N/A for ${modeOfTransport})` : "")
                }
                className="field-bg"
                value={
                  foreignPortOfLadingCode.id.length < 1
                    ? ""
                    : foreignPortOfLadingCode
                }
                currentCountry_aa="US"
                errors={transportationFields["foreignPortOfLadingCode"].errors}
                fullPayload={true}
                portType={modeOfTransport == "AIR" ? "AIRPORT" : "PORT"}
                onChange={(value) => {
                  updateTransportationField("foreignPortOfLadingCode", value);
                }}
                onBlur={(value) => {
                  let newObj = {
                    foreignPortOfLading: get(value, "title", "_BLANK_"),
                    foreignPortOfLadingCode: get(value, "payload", "_BLANK_"),
                    portKxId: get(value, "portKxId", "_BLANK_"),
                  };
                  if (get(value, "airportTimeZone")) {
                    newObj.sourceTimeZone = get(value, "airportTimeZone");
                  }
                  let foreignPortOfLadingCode =
                    newObj.foreignPortOfLadingCode === "_BLANK_"
                      ? ""
                      : newObj.foreignPortOfLadingCode;
                  this.validateField(
                    "foreignPortOfLadingCode",
                    foreignPortOfLadingCode
                  );
                  saveTransportationField("foreignPortOfLadingCode", newObj);
                  saveTransportationField("knlocidLading", newObj.portKxId);
                }}
                {...FIELD_META}
                hidePrefix={modeOfTransport == "AIR"}
              />
              <DropDown
                label="COUNTRY OF EXPORT"
                id="countryOfExport"
                className="field-bg dropdown100 noBorderRadius "
                isLabel={false}
                text={displayMasterItem(
                  entryTypeValues.countryOfExport,
                  countryList
                )}
                width={6}
                data={countryList}
                disabled={
                  this.state.enableForm === true
                    ? false
                    : isDisabled("countryOfExportEnabled")
                }
                errors={entryTypeFields["countryOfExport"].errors}
                onChange={(value) => {
                  updateEntryTypeField("countryOfExport", value);
                  saveEntryTypeField(
                    "countryOfExport",
                    value === "NONE" ? "_BLANK_" : value
                  );
                  // this.validateField('countryOfExport', value)
                }}
              />
              {truuck || raaiil ?
                <InputField
                  id="vesselCode"
                  label={"SCAC Code" }
                  width={6}
                  value={transportInfoValues.vesselCode}
                  errors={transportationFields["vesselCode"].errors}
                  onChange={(value) =>
                    updateTransportationField("vesselCode", value)
                  }
                  onBlur={(value) => {
                    this.validateField("vesselCode", value);
                    saveTransportationField("vesselCode", value);
                  }}
                  {...FIELD_META}
                  disabled={
                    this.state.enableForm === true
                      ? false
                      : isDisabled("conveyanceName")
                  }
                />
              
              
              :modeOfTransport == "AIR"?  (
                <InputField
                  id="importingCarrier"
                  label={"CONVEYANCE NAME"}
                  width={6}
                  value={transportInfoValues.importingCarrier}
                  errors={transportationFields["importingCarrier"].errors}
                  onChange={(value) =>
                    updateTransportationField("importingCarrier", value)
                  }
                  onBlur={(value) => {
                    this.validateField("importingCarrier", value);
                    saveTransportationField("importingCarrier", value);
                  }}
                  {...FIELD_META}
                  disabled={
                    this.state.enableForm === true
                      ? false
                      : isDisabled("conveyanceName")
                  }
                />
              ) : (
                <InputField
                  id="importingCarrier"
                  label="IMPORTING CARRIER"
                  width={6}
                  value={`${transportInfoValues.vesselCode} - ${
                    transportInfoValues.importingCarrier.title !== undefined
                      ? transportInfoValues.importingCarrier.title
                      : transportInfoValues.importingCarrier
                  } - ${transportInfoValues.tripInformation}`}
                  {...FIELD_META}
                  disabled={true}
                />
              )}
            </Form.Group>
            <Form.Group className="merged-row moved-up">
              <DateInputField
                id="exportDate"
                label="Export Date"
                width={5}
                //value={transportInfoValues.exportDate.epochs}
                value={
                  transportInfoValues.exportDate.epochs
                    ? new Date(
                        new Date(
                          transportInfoValues.exportDate.epochs
                        ).getUTCMonth() +
                          1 +
                          "/" +
                          new Date(
                            transportInfoValues.exportDate.epochs
                          ).getUTCDate() +
                          "/" +
                          new Date(
                            transportInfoValues.exportDate.epochs
                          ).getUTCFullYear()
                      ).getTime()
                    : -999
                }
                onChange={(value) => {
                  if (typeof value !== "string") {
                    //value = value && new Date(value.toGMTString());
                    this.validateField("exportDate", value);
                    if (value && !isNaN(value.getTime())) {
                      value = value.getTime();
                      value = new Date(
                        Date.UTC(
                          new Date(value).getFullYear(),
                          new Date(value).getMonth(),
                          new Date(value).getDate()
                        )
                      );
                      value = value.getTime();
                    } else value = -999;
                    updateTransportDate("exportDate", "epochs", value);
                    saveTransportationDateField("exportDate", value);
                  }
                }}
                errors={transportationFields["exportDate"].errors}
                disabled={
                  this.state.enableForm === true
                    ? false
                    : isDisabled("transportationSection")
                }
                {...FIELD_META}
              />



              <DateInputField
                id="arrivalDate"
                label={"Arrival Date "+destTimeZone}
                width={5}
                //value={transportInfoValues.arrivalDate.epochs}
                value={
                  transportInfoValues.arrivalDate.epochs
                    ? new Date(
                      transportInfoValues.arrivalDate.epochs
                        - (0 - differenceBetweenBrowserTZAndPortTZ)
                      ).getTime()
                    : -999
                }
                onChange={(value) => {
                  if (typeof value !== "string") {
                    //value = value && new Date(value.toGMTString());
                    this.validateField("arrivalDate", value);
                    if (value && !isNaN(value.getTime())) {
                      value = value.getTime() + (twelveHours - differenceBetweenBrowserTZAndPortTZ);
                    } else value = -999;
                    updateTransportDate("arrivalDate", "epochs", value);
                    saveTransportationDateField("arrivalDate", value);
                  }
                }}
                errors={transportationFields["arrivalDate"].errors}
                disabled={
                  this.state.enableForm === true
                    ? false
                    : isDisabled("importArrivalDateEnabled")
                }
                {...FIELD_META}
              />

              {/* {new Date(arrivalDate)+""}...
              {new Date(arrivalDate).toUTCString()},,, */}
              {/* <KNDatePicker
                label={"Arrival Date "+destTimeZone}
                name={"eta"}
                className={`arrivalDateEta`}
                id={"etaTransport"}
                timeDisabled={true}
                selected={
                  destTimeZone && destTimeZone!=='_BLANK_' && arrivalDate && arrivalDate != "-999"
                    ? 
                        new Date(arrivalDate + differenceBetweenBrowserTZAndPortTZ)//we have to convert to Browser time because KNDatepicker doesn't use the timezone
                      
                    : arrivalDate && arrivalDate != "-999"
                    ? shortDateFormatterV2WithoutTz(parseInt(arrivalDate))
                    : null
                }
                errors={transportationFields["arrivalDate"].errors}
                timezone={destTimeZone}
                modeoftransport={modeOfTransport}
                isDisabled={
                  this.state.enableForm === true
                    ? false
                    : isDisabled("transportationSection")
                }
                handleInputChange={(target) => {
                  let dt = get(target, "target.value") || "-999";
                  updateTransportDate("arrivalDate", "epochs", dt);
                  saveTransportationDateField("arrivalDate", dt);
                  window.shipmentETA = dt
                  // let newDt = (dt == '-999') ? dt : (dt - differenceBetweenPortTZAndUTC);
                  // this.validateField("arrivalDate", newDt);
                  // updateTransportDate("arrivalDate", "epochs", newDt);
                  // saveTransportationDateField("arrivalDate", newDt);
                }}
                isClearable={true}
              /> */}

              {/* <DateInputField
                id="arrivalDate"
                label={
                  truuck || raaiil ? "Arrival at Port of Entry" : "Arrival Date"
                }
                width={6}
                value={
                  transportInfoValues.destTimeZone &&
                  transportInfoValues.arrivalDate.epochs != "-999"
                    ? new Date(
                        new Date(
                          shortDateFormatterV2(
                            parseInt(transportInfoValues.arrivalDate.epochs) /
                              1000,
                            transportInfoValues.destTimeZone
                          )
                        )
                      )
                    : transportInfoValues.arrivalDate.epochs &&
                      transportInfoValues.arrivalDate.epochs != "-999"
                    ? shortDateFormatterV2WithoutTz(
                        parseInt(transportInfoValues.arrivalDate.epochs)
                      )
                    : null
                }
                tz={transportInfoValues.destTimeZone}
                //value={transportInfoValues.arrivalDate.epochs ? new Date((new Date(transportInfoValues.arrivalDate.epochs).getUTCMonth()+1)+"/"+new Date(transportInfoValues.arrivalDate.epochs).getUTCDate()+'/'+new Date(transportInfoValues.arrivalDate.epochs).getUTCFullYear()): -999}
                errors={transportationFields["arrivalDate"].errors}
                onChange={(value) => {
                  if (typeof value !== "string") {
                    this.validateField("arrivalDate", value);
                    if (value && !isNaN(value.getTime())) {
                      value = value.getTime();
                      value = new Date(
                        Date.UTC(
                          new Date(value).getFullYear(),
                          new Date(value).getMonth(),
                          new Date(value).getDate()
                        )
                      );
                      value = value.getTime();
                    } else value = -999;
                    updateTransportDate("arrivalDate", "epochs", value);
                    saveTransportationDateField("arrivalDate", value);
                  }
                }}
                disabled={
                  this.state.enableForm === true
                    ? false
                    : isDisabled("transportationSection")
                }
                {...FIELD_META}
              /> */}
              <DateInputField
                id="importDate"
                label="Import Date"
                errors={
                  fieldValidation.validObjects_bl[
                    `Transportqwqr${"importDate"}`
                  ]
                }
                width={6}
                value={
                  transportInfoValues.importDate.epochs
                    ? new Date(
                        new Date(
                          transportInfoValues.importDate.epochs
                        ).getUTCMonth() +
                          1 +
                          "/" +
                          new Date(
                            transportInfoValues.importDate.epochs
                          ).getUTCDate() +
                          "/" +
                          new Date(
                            transportInfoValues.importDate.epochs
                          ).getUTCFullYear()
                      ).getTime()
                    : -999
                }
                shipmentId={shipmentId}
                onChange={(value) => {
                  if (typeof value !== "string") {
                    this.validateField("importDate", value);
                    if (value && !isNaN(value.getTime())) {
                      value = value.getTime();
                      value = new Date(
                        Date.UTC(
                          new Date(value).getFullYear(),
                          new Date(value).getMonth(),
                          new Date(value).getDate()
                        )
                      );
                      value = value.getTime();
                    } else value = -999;
                    updateTransportDate("importDate", "epochs", value);
                    saveTransportationDateField("importDate", value);
                  }
                  
                  setTimeout(()=>
                   {document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();}
                  ,200)
                }}
                disabled={
                  this.state.enableForm === true
                    ? false
                    : isDisabled("importArrivalDateEnabled")
                }
                {...FIELD_META}
              />
            </Form.Group>
          </div>
        </Form>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  transportInfoValues: state.TransportationInfo,
  bolInfoValues: state.BOLInfo,
  modeOfTransportList: state.DropDownValues.modeOfTransportList,
  formDisabled: state.FormValues.formDisabled,
  countryList: state.DropDownValues.countryList,
  entryTypeValues: state.EntryTypeInfo,
  FIELD_META: {
    newValue: state.FormValues.newValue,
    rbCounterID: state.FormValues.newValue,
    fieldName: state.FormValues.fieldName,
    setINPUTID: state.FormValues.setINPUTID,
    penClicked: state.FormValues.penClicked,
    shipmentId: state.FormValues.shipmentId,
  },
  tabName: "transportation",
  pscData: state.PSC,
  fieldValidation: state.FieldValidation,
});

const mapDispatchToProps = {
  ...actionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransportationForm);
